import AdvanceRent from "@/components/common/Simulator/AdvanceRent";
import FundProjects from "@/components/common/Simulator/FundProjects";
import InvestInvoices from "@/components/common/Simulator/InvestInvoices";
import InvestProjects from "@/components/common/Simulator/InvestProjects";
import InvestRent from "@/components/common/Simulator/InvestRent";
import SellInvoices from "@/components/common/Simulator/SellInvoices";

export type IBlockAuthForms = {
  attrs: {
    anchor?: string;
    form?: string;
    getStarted?: {
      url?: string;
      target?: string;
    };
    knowMore?: {
      url?: string;
      target?: string;
    };
    title?: string;
    description?: string;
    whiteBackground?: boolean;
    termsDescription?: string;
    primaryButtonText?: string;
    secondaryButtonText?: string;
    showNotifyMe?: boolean;
  };
};

export default function BlockSimulatorForms({ attrs }: IBlockAuthForms) {
  const commonProps = {
    title: attrs?.title,
    description: attrs?.description,
    backgroundColor: attrs?.whiteBackground ? 'var(--color-white)' : undefined,
    termsDescription: attrs?.termsDescription,
    primaryButtonText: attrs?.primaryButtonText,
    secondaryButtonText: attrs?.secondaryButtonText,
    getStarted: attrs?.getStarted,
    knowMore: attrs?.knowMore,
    showNotifyMe: attrs?.showNotifyMe,
  };

  if (!attrs?.form || attrs?.form === "invest-invoices")
    return <InvestInvoices {...commonProps} />;
  else if (attrs?.form === "invest-projects")
    return <InvestProjects {...commonProps} />;
  else if (attrs?.form === "sell-invoices")
    return <SellInvoices {...commonProps} />;
  else if (attrs?.form === "fund-project")
    return <FundProjects {...commonProps} />;
  else if (attrs?.form === "invest-rent")
    return <InvestRent {...commonProps} />;
  else if (attrs?.form === "advance-rent")
    return <AdvanceRent {...commonProps} />;

  return <></>;
}
